import { LoadingSpinner } from "shared/ui/spinners/loading-spinner";

interface VerifyingStepPropsI {
  isReschedule?: boolean;
}

export const VerifyingStep = ({ isReschedule }: VerifyingStepPropsI) => (
  <div className="flex min-h-[300px] flex-col items-center justify-center">
    <LoadingSpinner className="mb-4" />
    <p className="text-center typography-body-4">
      {isReschedule
        ? "Checking AE calendar for rescheduled meeting..."
        : "Checking AE calendar for booked meeting..."}
    </p>
    <p className="mt-2 text-center text-base-content/60 typography-body-5">
      This may take a few seconds
    </p>
  </div>
);
